import React, { createContext, useMemo, useRef } from 'react'

type HeaderBag = Record<string, string>

type ApiHeadersContextValue = {
  headersRef: React.MutableRefObject<HeaderBag>
  set: (name: string, value: string) => void
  remove: (name: string) => void
  clear: () => void
  get: (name: string) => string | undefined
}

export type ApiHeadersMethods = Pick<
  ApiHeadersContextValue,
  'set' | 'remove' | 'clear' | 'get'
>

export const ApiHeadersContext = createContext<ApiHeadersContextValue | null>(
  null,
)

export const ApiHeadersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const headersRef = useRef<HeaderBag>({})

  const value = useMemo<ApiHeadersContextValue>(
    () => ({
      headersRef,
      set: (name: string, value: string): void => {
        headersRef.current[name] = value
      },
      remove: (name: string): void => {
        delete headersRef.current[name]
      },
      clear: (): void => {
        headersRef.current = {}
      },
      get: (name: string): string | undefined => headersRef.current[name],
    }),
    [],
  )

  return (
    <ApiHeadersContext.Provider value={value}>
      {children}
    </ApiHeadersContext.Provider>
  )
}
